package tools.goodtime.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.jetbrains.compose.web.css.cssRem
import tools.goodtime.components.layouts.PageLayoutData
import tools.goodtime.components.sections.FeaturesSection
import tools.goodtime.components.sections.HeroSection
import tools.goodtime.components.sections.ReviewsSection

@InitRoute
fun initHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Home"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun HomePage() {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(10.cssRem)) {
        HeroSection()
        FeaturesSection()
        ReviewsSection()
    }
}
